import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import cls from '../styles.module.scss'

export const TextContentIt = () => {
    return (
        <HighlightedText
            text="Bonus del 325% + 400 GIRI GRATUITI"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakAfterWords={['325%']}
            className={cls.text}
        />
    )
}
